
import { createReducer, on } from '@ngrx/store';
import { setNavbarState } from './app.actions';

export interface AppState {
  navBarState: string;
}

export const initialState: AppState = {
  navBarState: '',
};

export const appReducer = createReducer(
  initialState,
  on(setNavbarState, (state, { navBarState }) => ({
    ...state,
  }))
);
